<div class="animated fadeIn rounded">
  <div class="card">
    <div class="card-header">
      <i class="fa fa-book-open-reader"></i> Solicitudes de Crédito
    </div>
    <div class="card-body">
      <pos-table tableFormId="orderTable" [headers]="getHeaders()"
        [groupedFilters]="getGroupedFilters(this.selectedSalesOrgFilter)" [isGroupedFilters]="true"
        [data]="creditRequests" [badgeSuccessValues]="this.badgeSuccessValues"
        [badgeWarningValues]="this.badgeWarningValues" [badgeSecondaryValues]="this.badgeSecondaryValues"
        [badgeDangerValues]="this.badgeDangerValues" [disableHighlight]="true" [itemsPerPage]="20"
        [showRefreshButton]="true" (dataChange)="getData($event)"
        (updateSecondaryDatasources)="updateBranchesFilterDatasource($event)"
        highlightSuccessDangerField="hasRequirements">
      </pos-table>
    </div>
  </div>
</div>